<template>
  <div class="trilateralReservationDialog">
    <el-dialog
      title="三方客户预约"
      :visible.sync="visible"
      width="640px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div slot="title">
        <div class="dialog_header">
          <div class="dialog_header_title">三方客户预约</div>
          <div class="dialog_header_btn" @click="openRecord">预约记录</div>
        </div>
      </div>
      <div class="content" v-loading="loading">
        <el-form ref="form" class="dialog_form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="预约患者：" prop="patientId">
            <el-input class="form_patient_name" v-model="form.patientName" placeholder="患者姓名" disabled></el-input>
            <el-select class="form_patient_phone" v-model="form.patientId" filterable remote :remote-method="remotePatient" placeholder="患者手机号" clearable @change="selectPatient">
              <el-option v-for="item in patientList" :key="item.patientId" :label="item.phone" :value="item.patientId">
                <span style="width: 96px; display:inline-block" class="mr12">{{ item.patientName }}</span>
                <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth }}月</span>
                <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
              </el-option>
            </el-select>
            <el-button class="form_patient_btn" type="primary" plain @click="openAddPatient">新增患者</el-button>
          </el-form-item>
          <el-form-item label="预约项目：" prop="spuIds">
            <el-select class="form_input" v-model="form.spuIds" multiple filterable remote :remote-method="remoteProcutionList" placeholder="请选择" clearable @change="productChange">
              <el-option v-for="item in productList" :key="item.spuId" :label="item.physioName" :value="item.spuId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约日期：" prop="reservationDateTime">
            <el-date-picker
              class="form_input"
              v-model="form.reservationDateTime"
              type="date"
              :picker-options="pickerOptions"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
              @change="reservationDateChange">
            </el-date-picker>
          </el-form-item>
          <div v-if="form.spuIds.length > 0 && ![null, undefined, ''].includes(form.reservationDateTime)">
            <el-form-item class="form_item_doctor" label="执行人：" required>
              <div v-if="doctorList.length === 0">暂无可选执行人</div>
            </el-form-item>
            <div class="doctor_list">
              <div v-for="doctor in doctorList" :key="doctor.doctorId" :class="{ doctor_item: true, active: doctor.doctorId === form.doctorId }" @click="selectDoctor(doctor.doctorId)">
                <div class="doctor_item_portrait">
                  <img class="doctor_item_portrait_img" :src="doctor.doctorImgAddr">
                </div>
                <div class="doctor_item_name">{{ doctor.doctorName }}</div>
              </div>
            </div>
          </div>
          <div v-if="![null, undefined, ''].includes(form.doctorId)" class="scheduling_section">
            <el-form-item class="form_item_times" label="预约时段：" required>
              <div v-if="schedulingList.length === 0">暂无可选排班</div>
            </el-form-item>
            <div class="scheduling">
              <div v-for="classes in schedulingList" :key="classes.timeType" class="scheduling_classes">
                <div class="scheduling_classes_name">{{ classes.timeTypeName }}</div>
                <div class="scheduling_list">
                  <div
                    v-for="scheduling in classes.list"
                    :key="scheduling.vId"
                    :class="{ scheduling_item: true, active: scheduling.vId === form.schedulingItemVId, disabled: scheduling.disabled }"
                    @click="selectScheduling(scheduling)">
                    <div class="scheduling_item_time">{{ scheduling.appointmentStartTimeText }}-{{ scheduling.appointmentEndTimeText }}</div>
                    <div class="scheduling_item_status">{{ scheduling.describe }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="openConfirmDialog">确 定</el-button>
      </div>
    </el-dialog>
    <addPatient
      ref="addPatient"
      v-if="patientMap.addPatientDialog"
      :visibleObj="patientMap"
      @addPatientComfirm="addPatientComfirm"
      @close="addPatientClose">
    </addPatient>
    <TrilateralRecordDialog ref="trilateralRecordDialog"></TrilateralRecordDialog>
    <el-dialog title="确认预约信息" width="450px" v-if="confirmOrderMap.show" :visible="confirmOrderMap.show">
      <div class="confirmDialog">
        <div class="mb8">患者信息：{{ form.patientName }}/{{ form.sex == '0' ? '男' : '女' }}/{{ form.year }}岁</div>
        <div class="mb8">执行医师：<span class="color189">{{ form.doctorName }}</span></div>
        <div class="mb8">预约时间：{{ form.reservationDateTime }} <span class="color189">{{ form.appointmentStartTimeText }}-{{ form.appointmentEndTimeText }}</span></div>
        <div class="mb8">执行项目：{{ productSelectList.map(v => { return v.physioName }).join('、') }}</div>
        <div class="mb8">预计时长：{{ form.totalServerTime }}</div>
       </div>
         <div slot="footer">
        <el-button @click="confirmClose">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import addPatient from '@/components/addPatient'
  import TrilateralRecordDialog from '@/components/physio/trilateralRecordDialog'
  import { patientInfom } from "@/api/patient"
  import { getPhysioProcutions, getPhysioTrilateralReservationScheduling, postPhysioTrilateralReservation } from '@/api/physio.js'

  const timeTypeMap = {
    '1': '上午',
    '2': '中午',
    '3': '下午',
    '4': '晚上'
  }

  export default {
    name: 'trilateralReservationDialog',
    components: { addPatient, TrilateralRecordDialog },
    data () {
      return {
        visible: false,
        loading: false,
        patientList: [],
        productList: [],
        pickerOptions: {
          disabledDate (time) {
            return time.Format('yyyy-MM-dd') < new Date().Format('yyyy-MM-dd')
          }
        },
        doctorList: [],
        sourceSchedulingList: [],
        schedulingList: [],
        rules: {
          patientId: [{ required: true, message: '请选择预约患者', trigger: 'change' }],
          spuIds: [{ required: true, message: '请选择预约项目', trigger: 'change' }],
          reservationDateTime: [{ required: true, message: '请选择预约时间', trigger: 'change' }]
        },
        productSelectList: [],
        form: {
          patientId: '',
          patientName: '',
          sex: '',
          year: '',
          spuIds: [],
          reservationDateTime: '',
          doctorId: '',
          schedulingItemVId: '',
          appointmentStartTimeText:'',
          appointmentEndTimeText:'',
          totalServerTime:''
        },
        patientMap: {
          addPatientDialog: false
        },
        confirmOrderMap: {
          show: false
       }
      }
    },
    methods: {
      openRecord () {
        this.$refs['trilateralRecordDialog'].open()
      },
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      open () {
        this.visible = true
      },
      async remotePatient (value) {
        const res = await patientInfom({ phone: value })
        this.patientList = []
        if (res.code == 200) {
          this.patientList = res.data.map(v => {
            this.$computeAge(v.birthday, v)
            return v
          })
        }
      },
      selectPatient (id) {
        if (![null, undefined, ''].includes(id)) {
          const patient = this.patientList.find(v => v.patientId === id)
          this.form.patientName = patient.patientName
          this.form.sex = patient.sex
          this.form.year = patient.age
        } else {
          this.form.patientName = ''
          this.form.sex = ''
          this.form.year = ''
        }
      },
      async remoteProcutionList (name) {
        if (![null, undefined, ''].includes(name)) {
          const res = await getPhysioProcutions({ pageNum: 1, pageSize: 1000, physioName: name, searchMeiTuan: 1 })
          if (res.code === 200) {
            this.productList = res.rows || []
          }
        } else {
          this.productList = []
        }
      },
      productChange (selectList) {
        let list = []
        if (selectList) {
          selectList.forEach(v1 => {
            const hasProduct = this.productSelectList.find(v2 => v2.spuId === v1)
            if (hasProduct) {
              list.push(hasProduct)
            } else {
              const product = this.productList.find(v2 => v2.spuId === v1)
              list.push({
                spuId: v1,
                physioName: product.physioName
              })
            }
          })
        }
        this.productSelectList = list
        this.doctorList = []
        this.form.doctorId = ''
        this.form.doctorName = ''
        this.schedulingList = []
        this.form.schedulingItemVId = ''
        this.getDoctorList()
      },
      reservationDateChange () {
        this.doctorList = []
        this.form.doctorId = ''
        this.form.doctorName = ''
        this.schedulingList = []
        this.form.schedulingItemVId = ''
        this.form.appointmentEndTimeText = ''
        this.form.appointmentStartTimeText = ''
        this.getDoctorList()
      },
      async getDoctorList () {
        if (this.form.spuIds.length > 0 && ![null, undefined, ''].includes(this.form.reservationDateTime)) {
          const res = await getPhysioTrilateralReservationScheduling({
            deptId: sessionStorage.getItem('deptId'),
            spuIds: this.form.spuIds,
            reservationDateTime: this.form.reservationDateTime
          })
          if (res.code === 200) {
            this.doctorList = res.data && res.data.map(v => {
              const info = {
                doctorId: v.doctor.doctorId,
                doctorName: v.doctor.doctorName,
                doctorImgAddr: v.doctor.doctorImgAddr,
                totalServerTime:v.totalServerTime,
                schedulingList: []
              }

              const schedulingList = v.reservationNoticeBoards && v.reservationNoticeBoards.map(scheduling => {
                scheduling['vId'] = this.generateUUID()
                scheduling['date'] = new Date(scheduling.appointmentStartDateTime).Format('yyyy-MM-dd')
                scheduling['appointmentStartDateTime'] = new Date(scheduling.appointmentStartDateTime).Format('yyyy-MM-dd hh:mm:ss')
                scheduling['appointmentEndDateTime'] = new Date(scheduling.appointmentEndDateTime).Format('yyyy-MM-dd hh:mm:ss')
                scheduling['appointmentStartTimeText'] = new Date(scheduling.appointmentStartDateTime).Format('hh:mm')
                scheduling['appointmentEndTimeText'] = new Date(scheduling.appointmentEndDateTime).Format('hh:mm')
                scheduling['timeTypeName'] = timeTypeMap[scheduling.timeType]
                scheduling['releaseStatus'] = true
                scheduling['disabled'] = false
                scheduling['describe'] = '可约'
                switch (true) {
                  case scheduling.status === '1':
                    scheduling.describe = '停诊'
                    scheduling.disabled = true
                    break
                  case !scheduling.releaseStatus:
                    scheduling.describe = '未放号'
                    scheduling.disabled = true
                    break
                  case new Date(scheduling.appointmentEndDateTime).getTime() < new Date().getTime():
                    scheduling.describe = '完诊'
                    scheduling.disabled = true
                    break
                  case !scheduling.useReservation:
                    scheduling.describe = '约满'
                    scheduling.disabled = true
                    break
                }
                return scheduling
              }) || []

              info.schedulingList = schedulingList

              return info
            })
          }
        } else {
          this.doctorList = []
        }
      },
      selectDoctor (doctorId) {
        if (doctorId !== this.form.doctorId) {
          this.form.doctorId = doctorId
          this.form.schedulingItemVId = ''

          const doctor = this.doctorList.find(item => item.doctorId == doctorId)
          this.form.totalServerTime = doctor.totalServerTime
          this.form.doctorName = doctor.doctorName
          this.sourceSchedulingList = doctor.schedulingList

          this.schedulingList = doctor.schedulingList.reduce((res, cur) => { 
            const resType = res.find(v => v.timeType === cur.timeType)
            if (resType) {
              resType.list.push(cur)
            } else {
              res.push({
                timeType: cur.timeType,
                timeTypeName: cur.timeTypeName,
                list: [cur]
              })
            }
            return res
          }, [])
        }
      },

      selectScheduling (item) {
        const scheduling = this.sourceSchedulingList.find(v => v.vId === item.vId)
        if (scheduling.disabled) {
          return false
        }
        this.form.schedulingItemVId = item.vId
        this.form.appointmentStartTimeText =  item.appointmentStartTimeText
        this.form.appointmentEndTimeText =  item.appointmentEndTimeText
      },
      openAddPatient () {
        this.patientMap.addPatientDialog = true
      },
      addPatientComfirm (info) {
        this.$message.success('新增成功')
        this.patientList = [{
          patientId: info.patientId,
          patientName: info.patientName,
          phone: info.phone,
          sex: info.sex,
          age: info.age,
          ageMth: info.ageMth,
          birthday: info.birthday
        }]
        this.form.patientId = info.patientId
        this.form.patientName = info.patientName
        this.form.sex = info.sex
        this.form.year = info.age
        this.patientMap.addPatientDialog = false
      },
      addPatientClose () {
        this.patientMap.addPatientDialog = false
      },
      close () {
        this.visible = false
        this.patientList = []
        this.productList = []
        this.doctorList = []
        this.sourceSchedulingList = []
        this.schedulingList = []
        this.form.patientId = ''
        this.form.patientName = ''
        this.form.sex = ''
        this.form.year = ''
        this.form.spuIds = []
        this.form.reservationDateTime = ''
        this.form.doctorId = ''
        this.form.schedulingItemVId = ''
      },
      submit () {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            if ([null, undefined, ''].includes(this.form.doctorId)) {
              this.$message.error('请选择执行人')
              return
            }
            if ([null, undefined, ''].includes(this.form.schedulingItemVId)) {
              this.$message.error('请选择预约时段')
              return
            }
            const scheduling = this.sourceSchedulingList.find(v => v.vId === this.form.schedulingItemVId)
            if (scheduling) {
              this.loading = true
              const res = await  postPhysioTrilateralReservation({
                deptId: sessionStorage.getItem('deptId'),
                patientId: this.form.patientId,
                spuIds: this.form.spuIds,
                doctorId: this.form.doctorId,
                schedulingItemId: scheduling.schedulingItemId,
                startTime: scheduling.appointmentStartDateTime,
                endTime: scheduling.appointmentEndDateTime,
                source: 'platform-intermediary',
                plat: 1
              })
              this.loading = false
              if (res.code === 200) {
                this.$message.success('预约成功')
                this.close()
                this.confirmClose()
              }
            }
          }
        })
      },
      openConfirmDialog(){
        this.confirmOrderMap.show = true
      },
      confirmClose(){
        this.confirmOrderMap.show = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .trilateralReservationDialog {
    overflow: hidden;
  }

  .trilateralReservationDialog /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #E5E6EB !important;
  }

  .trilateralReservationDialog /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #1F2329;
  }
  
  .trilateralReservationDialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .trilateralReservationDialog /deep/ .el-dialog__footer {
    padding: 12px 20px;
  }

  .dialog_header {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 28px;
  }

  .dialog_header_title {
    font-weight: bold;
    font-size: 16px;
    color: #1F2329;
  }

  .dialog_header_btn {
    box-sizing: border-box;
    margin: 0 32px 0 0;
    padding: 0 10px;
    height: 28px;
    line-height: 26px;
    font-size: 14px;
    color: #1890FF;
    border: 1px solid #1890FF;
    border-radius: 2px;
    cursor: pointer;
  }

  .content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .dialog_form {
    overflow: hidden;
  }

  .dialog_form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #333333;
  }

  .dialog_form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_patient_name {
    width: 120px;
  }

  .form_patient_phone {
    margin: 0 0 0 12px;
    width: 228px;
  }

  .form_patient_btn {
    margin: 0 0 0 12px;
  }

  .form_input {
    width: 360px;
  }

  .form_item_doctor {
    margin: 0 0 0 0;
  }

  .doctor_list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 4px -12px -12px 0;
    width: calc(100% + 12px);
    overflow: hidden;
  }

  .doctor_item {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 12px 12px 0;
    padding: 0 12px;
    height: 50px;
    background-color: #FFFFFF;
    border: 1px solid #D5D5D5;
    border-radius: 6px;
    cursor: pointer;
  }

  .doctor_item.active {
    background-color: #FFF5EA;
    border-color: #E3874F;
  }

  .doctor_item_portrait {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    background-color: #FFFFFF;
  }

  .doctor_item_portrait_img {
    width: 100%;
    height: 100%;
  }

  .doctor_item_name {
    margin: 0 0 0 8px;
    font-size: 14px;
    color: #1F2329;
  }

  .scheduling_section {
    margin: 24px 0 0 0;
  }

  .form_item_times {
    margin: 0 0 0 0;
  }

  .scheduling {
    margin: 4px 0 0 0;
    width: 100%;
    overflow: hidden;
  }

  .scheduling_classes {
    width: 100%;
  }

  .scheduling_classes+.scheduling_classes {
    margin: 16px 0 0 0;
  }

  .scheduling_classes_name {
    line-height: 17px;
    font-size: 12px;
    color: #999999;
  }

  .scheduling_list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 8px -12px -12px 0;
    width: calc(100% + 12px);
  }

  .scheduling_item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 12px 12px 0;
    width: 141px;
    height: 50px;
    background-color: #FFFFFF;
    border: 1px solid #D5D5D5;
    border-radius: 6px;
    cursor: pointer;
  }

  .scheduling_item.active {
    background-color: #FFF5EA;
    border-color: #E3874F;
  }

  .scheduling_item.disabled {
    background-color: #EAE9E9;
    opacity: 0.4;
  }

  .scheduling_item_time {
    line-height: 20px;
    font-size: 14px;
    color: #1F2329;
  }

  .scheduling_item_status {
    line-height: 14px;
    font-size: 10px;
    color: #1F2329;
  }
  .confirmDialog{
    padding: 20px;
    color: #000;
  }
</style>